import { blendConvictionPpb, fixedPowPpb } from './conviction.js';

export interface ConvictionProjectionSnapshot {
  readonly anchorPpb: bigint;
  readonly targetPpb: bigint;
  readonly updatedAtSecs: bigint;
  readonly retentionPerSecondPpb: bigint;
}

/** Exact whole-second endpoints; integer interpolation is display-only. */
export function createConvictionProjection(
  snapshot: ConvictionProjectionSnapshot,
): (nowMs: bigint) => bigint {
  let second = -1n;
  let left = snapshot.anchorPpb;
  let right = left;
  return (nowMs) => {
    const elapsed =
      nowMs > snapshot.updatedAtSecs * 1000n ? nowMs - snapshot.updatedAtSecs * 1000n : 0n;
    const nextSecond = elapsed / 1000n;
    if (nextSecond !== second) {
      second = nextSecond;
      left = blendConvictionPpb(
        snapshot.anchorPpb,
        snapshot.targetPpb,
        fixedPowPpb(snapshot.retentionPerSecondPpb, second),
      );
      right = blendConvictionPpb(
        snapshot.anchorPpb,
        snapshot.targetPpb,
        fixedPowPpb(snapshot.retentionPerSecondPpb, second + 1n),
      );
    }
    const millis = elapsed % 1000n;
    return (left * (1000n - millis) + right * millis) / 1000n;
  };
}
